import { injectable } from "inversify";
import { TableRepo } from "../table.repo";
import { FactoryBillingModel } from "@/core/models/factory-billing.model";



@injectable()
export class FactoryBillingRepo extends TableRepo<FactoryBillingModel> {
    constructor() {
        super("/api/factoryBilling");
    }
    async getDetail(id: string): Promise<FactoryBillingModel> {
        try {
            const response = await this.apiRepo.get<FactoryBillingModel>(`${this.basepath}/detail`, {id});
            if (response?.code === '00') {
                return response.result
            };
        } catch (err) {
            console.log(err);
        }
        return {} as FactoryBillingModel;
    }
    async GetByWaterFactory(): Promise<FactoryBillingModel> {
        try {
            const response = await this.apiRepo.get<FactoryBillingModel>(`${this.basepath}/get-by-water-factory`);
            if (response?.code === '00') {
                return response.result
            };
        } catch (err) {
            console.log(err);
        }
        return {} as FactoryBillingModel;
    }

    async updateEInvoiceNotificationDay(eInvoiceNotificationDay: number | null): Promise<{ success: boolean; message?: string }> {
        try {
            const response = await this.apiRepo.post<{ eInvoiceNotificationDay?: number | null }>(
                `${this.basepath}/update-einvoice-notification-day`,
                { eInvoiceNotificationDay }
            );
            if (response?.code === '00') {
                return { success: true };
            }
            return { success: false, message: response?.errorMessage || 'Cập nhật thất bại' };
        } catch (err) {
            console.log(err);
            return { success: false, message: 'Có lỗi xảy ra khi cập nhật' };
        }
    }
}